export default function Contact() {
  const handleCall = () => {
    window.location.href = 'tel:+68987735594';
  };

  const handleDirections = () => {
    window.open('https://maps.app.goo.gl/mstvfpB822vCTHHA9', '_blank');
  };

  const handleMenu = () => {
    document.getElementById('menu-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-600 via-emerald-700 to-teal-700"></div>
      
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Info */}
          <div>
            <h2 className="text-5xl sm:text-6xl font-serif text-white mb-6">
              Venez nous voir
            </h2>
            
            <p className="text-xl text-white/90 mb-8 font-light leading-relaxed">
              Que ce soit pour un déjeuner sur notre terrasse, un dîner romantique ou un cocktail entre amis, nous serons ravis de vous accueillir.
            </p>

            <div className="space-y-4 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-md rounded-2xl">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-white font-medium text-lg">Adresse</p>
                  <p className="text-white/90">Moorea-Maiao 98728, Polynésie française</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-md rounded-2xl">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-white font-medium text-lg">Téléphone</p>
                  <p className="text-white/90">+689 87 73 55 94</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-md rounded-2xl">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-white font-medium text-lg">Email</p>
                  <a href="mailto:ke.iki@hotmail.com" className="text-white/90 hover:text-white transition-colors cursor-pointer">ke.iki@hotmail.com</a>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleCall}
                className="flex items-center justify-center gap-2 px-8 py-4 bg-white hover:bg-gray-50 text-emerald-700 text-lg font-medium rounded-full shadow-lg hover:shadow-xl transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Appeler
              </button>
              
              <button
                onClick={handleDirections}
                className="flex items-center justify-center gap-2 px-8 py-4 bg-white/20 backdrop-blur-md border border-white/30 hover:bg-white/30 text-white text-lg font-medium rounded-full transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-pin-line text-xl"></i>
                Itinéraire
              </button>
              
              <button
                onClick={handleMenu}
                className="flex items-center justify-center gap-2 px-8 py-4 bg-white/20 backdrop-blur-md border border-white/30 hover:bg-white/30 text-white text-lg font-medium rounded-full transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-restaurant-line text-xl"></i>
                Menu
              </button>
            </div>
          </div>

          {/* Right: Map */}
          <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.5382436580758!2d-149.8042409248329!3d-17.48180148342161!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x769a213d903d2465%3A0x9c417725d087bdb8!2sKE%27IKI!5e0!3m2!1sfr!2sfr!4v1772681898151!5m2!1sfr!2sfr"
              width="100%"
              height="500"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Carte KEIKI Moorea"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}